import {NgModule} from '@angular/core'
import {HolyGrailGridComponent} from './holy-grail-grid.component'
import {HolyGrailGridColLeftComponent} from './holy-grail-grid-col-left/holy-grail-grid-col-left.component'
import {HolyGrailGridColRightComponent} from './holy-grail-grid-col-right/holy-grail-grid-col-right.component'
import {HolyGrailGridContentComponent} from './holy-grail-grid-content/holy-grail-grid-content.component'
import {HolyGrailGridSidenavComponent} from './holy-grail-grid-sidenav/holy-grail-grid-sidenav.component'
import {RouterLink} from '@angular/router'
import {NgIf} from '@angular/common'
import {FaIconComponent} from '@fortawesome/angular-fontawesome'
import {HolyGrailGridSidenavListItemComponent} from './holy-grail-grid-sidenav/holy-grail-grid-sidenav-list-item.component'
import {HolyGrailGridSidenavSubmenuComponent} from './holy-grail-grid-sidenav/holy-grail-grid-sidenav-submenu.component'
import {HolyGrailGridSidenavSubmenuItemComponent} from './holy-grail-grid-sidenav/holy-grail-grid-sidenav-submenu-item.component'
import {HolyGrailGridSidenavListComponent} from './holy-grail-grid-sidenav/holy-grail-grid-sidenav-list.component'

@NgModule({
  declarations: [
    HolyGrailGridComponent,
    HolyGrailGridContentComponent,
    HolyGrailGridColRightComponent,
    HolyGrailGridColLeftComponent,
    HolyGrailGridSidenavComponent,
    HolyGrailGridSidenavListComponent,
    HolyGrailGridSidenavListItemComponent,
    HolyGrailGridSidenavSubmenuComponent,
    HolyGrailGridSidenavSubmenuItemComponent,
  ],
  exports: [
    HolyGrailGridComponent,
    HolyGrailGridContentComponent,
    HolyGrailGridColRightComponent,
    HolyGrailGridColLeftComponent,
    HolyGrailGridSidenavComponent,
  ],
  imports: [RouterLink, NgIf, FaIconComponent],
})
export class HolyGrailGridModule {}
